import styled from '@emotion/styled';
import theme from '../../../styles/theme';

export const AllProductsLabel = styled.span`
  text-decoration: line-through;
  color: ${theme.colors.gradientGreen};
`;
